import { useQuery } from '@tanstack/react-query';
import planApiClient from '../../../api/plan';

export const usePlansQuery = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['plans'],
    queryFn: () => planApiClient.getActivePlans(),
    enabled,
  });
};

export const usePlanByIdQuery = (planId: string | null) => {
  return useQuery({
    queryKey: ['plan', planId],
    queryFn: () => planApiClient.getPlanById(planId!),
    enabled: !!planId,
  });
};

export default usePlansQuery;
